import { useContext } from "react";
import { DeliveryFoodContext } from "../../../../DeliveryFoodContext";
import { DeliveryFoodItemCommissaryCell } from "../../../../types/DeliveryFoodTypes";
import DeliveryFoodCell from "../../DeliveryFoodCell";

export const DeliveryFoodItemCommissaryOnHandCell = ({
    config,
}: {
    config: DeliveryFoodItemCommissaryCell;
}) => {
    const { deliveryFoodState } = useContext(DeliveryFoodContext);
    const { commissary, index, ingredient } = config;

    if (deliveryFoodState.mode.display.COM.onHand === false) {
        return null;
    }

    const key = `on-hand-cell-${index}`;
    const commissaryId: string | number = commissary.data?.id || "";

    if (!commissaryId) {
        return null;
    }

    if (!ingredient.results.COM) {
        return null;
    }

    const summary = ingredient.results.COM.onHand;

    if (!summary) {
        return null;
    }

    return (
        <DeliveryFoodCell
            key={key}
            fieldName={"onHand"}
            styleName={"ON_HAND"}
            summary={summary}
            index={index}
            ingredient={ingredient}
            restaurant={commissary}
        />
    );
};
